import Lightbox from '../utils/_lightbox'

const $ = jQuery

export default function Gallery () {
  const GALLERIES = document.querySelectorAll('.mtt-gallery')
  if (GALLERIES.length > 0) {
    for (let i = 0; i < GALLERIES.length; i++) {
      const galleryClass = new GalleryClass(GALLERIES[i])
      galleryClass.init()
    }
  }
}

class GalleryClass {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.LOADER = this.WRAPPER.querySelector('.mtt-gallery__loader')
    this.LOAD_BUTTON = this.WRAPPER.querySelector('.mtt-gallery__load-all')
    this.TARGET = this.WRAPPER.querySelector('.mtt-gallery__target')
    this.markup = ''
    this.data = {
      action: 'load_gallery',
      gallery_id: null
    }
  }

  init () {
    if (!this.LOAD_BUTTON || !this.TARGET || !this.LOADER) return

    // update id
    this.data.gallery_id = this.LOAD_BUTTON.getAttribute('data-gallery-id')

    this.LOAD_BUTTON.addEventListener('click', () => {
      this.LOADER.classList.add('loader--show')

      $.post(main_theme_objects.ajax_url, this.data,
        response => {
          this.LOADER.classList.remove('loader--show')
          this.LOAD_BUTTON.classList.add('disabled')
          if (response.markup !== '') {
            this.TARGET.innerHTML = response.markup
            this.initLightboxes()
          }
        }
      )
    })
  }

  initLightboxes () {
    const ligthbox = new Lightbox(this.WRAPPER.querySelectorAll('.mtt-gallery__image img'))
  }
}
